export default __webpack_public_path__ + "static/kenneth_auchenberg-8e8c0c518a95e3fbca2bef5fac212342.jpg";